<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import tatApiSvc from "@/services/tat-api";
import { toast } from "vue3-toastify";
import { DateTime } from "luxon";

export default {
  page: {
    title: "Manage Event",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Manage ATP",
      role:
        localStorage.getItem("userInfo") !== null
          ? JSON.parse(localStorage.getItem("userInfo")).role
          : "user",
      items: [
        {
          text: "Third Party",
          href: "list",
        },
        {
          text: "Manage ATP",
          active: true,
        },
      ],
      isDisabled: true,
      tatData: {
        thaiFestUuid: "",
        documentId: "",
        eventFestivalName: "",
        eventType: "",
        details: "",
        region: "",
        province: "",
        contactNumber: "",
        thumbImage: "",
        startDate: "",
        endDate: "",
        dateCreated: "",
        dateUpdated: "",
        facebook: "",
        instagram: "",
        youtube: "",
        website: "",
        imageGallery: [],
      },
      cloneAlready: false,
    };
  },
  mounted() {
    this.get(this.$route.query.uuid);
  },
  methods: {
    get(uuid) {
      tatApiSvc
        .getAptDetail(uuid)
        .then((resp) => {
          if (resp?.data?.data) {
            const d = resp.data.data;
            this.tatData.thaiFestUuid = d.cloneUUID || "";
            this.tatData.documentId = d.documentId || "";
            this.tatData.eventFestivalName = d.eventFestivalName || "";
            this.tatData.eventType = d.eventType || "";
            this.tatData.details = d.details || "";
            this.tatData.region = d.region || "";
            this.tatData.province = d.province || "";
            this.tatData.contactNumber = d.contactNumber || "";
            this.tatData.thumbImage =
              d.imageBanner?.formats?.small?.url ||
              d.imageBanner?.url ||
              "";
            this.tatData.startDate = d.eventStartDate || "";
            this.tatData.endDate = d.eventEndDate || "";
            this.tatData.facebook = d.facebook || "";
            this.tatData.instagram = d.instagram || "";
            this.tatData.youtube = d.youtube || "";
            this.tatData.website = d.website || "";
            this.tatData.imageGallery = d.imageGallery || [];
            this.cloneAlready = d.isClone;
            this.tatData.dateCreated = d.createdAt
              ? DateTime.fromISO(d.createdAt).toFormat("yyyy-MM-dd")
              : "";
            this.tatData.dateUpdated = d.updatedAt
              ? DateTime.fromISO(d.updatedAt).toFormat("yyyy-MM-dd")
              : "";
          } else {
            toast.error("data not found", {
              autoClose: localStorage.getItem("toastCountdown"),
            });
            this.$router.push("list");
          }
        })
        .catch((err) => {
          console.log(">>>", err);
          toast.error("data not found", {
            autoClose: localStorage.getItem("toastCountdown"),
          });
          this.$router.push("list");
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <form class="needs-validation">
            <div class="row">
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Document ID</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.documentId"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Category</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.eventType"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Start Date</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.startDate"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">End Date</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.endDate"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3 position-relative">
                      <label for="">Name (TH)</label>
                      <input
                        :disabled="isDisabled"
                        v-model="tatData.eventFestivalName"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-3 position-relative">
                      <label for="">Detail (TH)</label>
                      <textarea
                        :disabled="isDisabled"
                        v-model="tatData.details"
                        class="form-control"
                        rows="15"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Region</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.region"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Province</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.province"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Phone</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.contactNumber"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Facebook</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.facebook"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Instagram</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.instagram"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">YouTube</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.youtube"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Website</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.website"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Created At</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.dateCreated"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Updated At</label>
                  <input
                    :disabled="isDisabled"
                    v-model="tatData.dateUpdated"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <hr />
              <div class="col-md-3">
                <div class="mb-3 position-relative">
                  <label for="">Thumbnail</label>
                  <div v-if="tatData.thumbImage" class="tat-thumbnail">
                    <img alt="thumbnail" :src="tatData.thumbImage" />
                  </div>
                </div>
              </div>
              <hr />
              <div class="col-md-12">
                <div class="mb-3 position-relative">
                  <label for="">Gallery</label>
                  <div class="tat-gallery">
                    <div
                      v-for="img in tatData.imageGallery"
                      :key="img.id"
                      class="tat-gallery-item"
                    >
                      <img
                        :alt="img.name"
                        :src="img.formats?.small?.url || img.url"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-sm-end">
              <b-button
                v-if="cloneAlready"
                router-link
                :to="`../event/manage?uuid=${tatData.thaiFestUuid}`"
                class="btn btn-warning ms-1"
                ro
              >
                View Duplicate
              </b-button>
              <b-button
                v-else
                router-link
                :to="`../event/manage?apt=${tatData.documentId}`"
                class="btn btn-success ms-1"
              >
                Clone Data
              </b-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.form-control[type="text"],
.form-control[type="number"],
.form-control[type="date"] {
  height: 40px !important;
}

.tat-thumbnail img {
  width: 400px !important;
}

.tat-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tat-gallery-item img {
  width: 150px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}
</style>
